<template>
  <div class="modal-wrapper">
    <div class="modal">
      <header>
        <h2>{{ header }}</h2>
      </header>

      <div class="buttons">
        <a
          :href="`https://www.facebook.com/sharer/sharer.php?u=${this.url}&t=${this.text}`"
          onclick="javascript:window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600');return false;"
          target="_blank"
          title="Deel op Facebook"
          class="button"
        >
          <div class="icon">
            <font-awesome-icon icon="fa-brands fa-facebook-f" />
          </div>
          <div class="label">Facebook</div>
        </a>

        <a
          :href="`https://twitter.com/share?url=${this.url}&text=${this.text}`"
          onclick="javascript:window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');return false;"
          target="_blank"
          title="Deel op Twitter"
          class="button"
        >
          <div class="icon">
            <font-awesome-icon icon="fa-brands fa-twitter" />
          </div>
          <div class="label">Twitter</div>
        </a>
      </div>

      <font-awesome-icon
        icon="fa-solid fa-circle-xmark"
        class="close"
        @click="toggleShareModal()"
      />
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      header: (state) => state.dictionary.share.header,
      share_text: (state) => state.dictionary.share.share_text,
    }),

    url() {
      return encodeURI(window.location.origin);
    },
    text() {
      return this.share_text ? this.share_text : document.title;
    },
  },

  methods: {
    ...mapMutations(["toggleShareModal"]),
  },
};
</script>

<style lang="scss" scoped>
.modal-wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
}

.modal {
  background: white;
  display: flex;
  flex-direction: column;
  border-radius: $border-radius;
  padding: 20px;
  width: 100%;
  max-width: 350px;
  text-align: center;
  position: relative;
  color: $blue;
}

header {
  @include type-large();
  @include type-strong();
  margin-bottom: 20px;
}

a {
  text-decoration: none;
  color: inherit;
}

.buttons {
  display: flex;
  justify-content: center;
  align-items: center;
}

.button {
  display: block;
}

.icon {
  width: 50px;
  height: 50px;
  border-radius: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: $blueOpacity;
  font-size: 22px;
  margin: 0 10px;
}

.label {
  @include type-small();
  @include type-strong();
  margin-top: 5px;
}

.close {
  font-size: 18px;
  position: absolute;
  right: 20px;
  top: 20px;
  color: $pink;
  cursor: pointer;
}
</style>
